import axios from "@/libs/api.request";
// 获取列表
export const getTrace = params => {
  return axios.request({
    url: "/tracker/trace",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/tracker/trace/batchAddTrace",
    method: "post",
    data
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/tracker/trace/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/tracker/trace/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const deleteL = id => {
  return axios.request({
    url: `/tracker/trace/${id}`,
    method: "DELETE"
  });
};
